import { allValues, Rights } from '../rights';

export const ADMINISTRATOR_RIGHTS = Object.freeze([
  ...allValues(Rights.RESIDENTS),
  ...allValues(Rights.EMPLOYEES),
  ...allValues(Rights.BASE_DATA),
  ...allValues(Rights.CARE),
  ...allValues(Rights.ADMINISTRATION_AND_INVOICING),
  ...allValues(Rights.GENERAL),
  Rights.ROSTER.MANAGE.key,
  Rights.ROSTER.ADMINISTRATE.key,
  Rights.ROSTER.PRINT.key,
  Rights.ROSTER.ACCESS.READ.key,
  Rights.ROSTER.ACCESS.WRITE.key,
  Rights.ROSTER.WEEK_PLAN.key,
  ...allValues(Rights.LISTS),
  ...allValues(Rights.ROSTER.VACATION_SCHEDULE),
  Rights.ADMINISTRATORS.ADMINISTRATOR_ONLY.key,
]);
